import React from 'react'
import {  useTranslation } from "react-i18next";
import realmobilebanner from "../../../assets/homeimages/RealEstate_Banner.png";
import insurancemobilebanner from "../../../assets/homeimages/Investment_Banner.png";
import mortgagemobilebanner from "../../../assets/homeimages/Mortgage_Banner.png";
import investmentmobilebanner from "../../../assets/homeimages/Insurance_Banner.png";
import Bankingmobilebanner from "../../../assets/homeimages/Banking_Banner.png";
import rimib11 from "../../../assets/homeimages/RealEstateblack.svg";
import rimib22 from "../../../assets/homeimages/Investmentblack.svg";
import rimib33 from "../../../assets/homeimages/Mortgageblack.svg";
import rimib44 from "../../../assets/homeimages/Insuranceblack.svg";
import rimib55 from "../../../assets/homeimages/Bankingblack.svg";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
export const HomeMobileBannerJsx = (props) => {

    const { t } = useTranslation();



    return (
        <>
        <section className="d-block d-sm-none">
                    <div className="newblock">{t("HOMEPAGE.MOBILETAGLINE")}</div>
                     <Tabs
      defaultActiveKey="tabrealestate"      id="rimib"       className="rimibblock "
    >
      <Tab eventKey="tabrealestate" title="Real Estate" className="tabrealestate">
          
      <div className="bannerimagmobile">
          <button className="mobileabso" onClick={() => window.location.href='category/realEstate'}>{t("HOMEPAGE.REALESTATE")}<span><img src={rimib11} alt='{t("HOMEPAGE.REALESTATE")}'/></span> </button> 
          <img src={realmobilebanner} alt='{t("HOMEPAGE.REALESTATE")}'/>
      </div>
      </Tab>
      <Tab eventKey="tabinvesment" title="Invesment" className="tabinvesment">
      <div className="bannerimagmobile">
          <button className="mobileabso" onClick={() => window.location.href='category/investment'}>{t("HOMEPAGE.INVESTMENT")} <span><img src={rimib22} alt='{t("HOMEPAGE.INVESTMENT")}'/></span> </button> 
          <img src={insurancemobilebanner} alt='{t("HOMEPAGE.INVESTMENT")}'/>
      </div>
      </Tab>
      <Tab eventKey="tabmortgage" title="Mortgage"  className="tabmortgage">
      <div className="bannerimagmobile">
          <button className="mobileabso" onClick={() => window.location.href='category/mortgage'}>{t("HOMEPAGE.MORTGAGE")} <span><img src={rimib33} alt='{t("HOMEPAGE.MORTGAGE")}'/></span> </button> 
          <img src={mortgagemobilebanner} alt='{t("HOMEPAGE.MORTGAGE")}'/>
      </div>
      </Tab>
      <Tab eventKey="tabinsurance" title="Insurance"  className="tabinsurance">
      <div className="bannerimagmobile">
          <button className="mobileabso" onClick={() => window.location.href='category/insurance'}>{t("HOMEPAGE.INSURANCE")} <span><img src={rimib44} alt='{t("HOMEPAGE.INSURANCE")}'/></span> </button> 
          <img src={investmentmobilebanner} alt='{t("HOMEPAGE.INSURANCE")}'/>
      </div>
      </Tab>
      <Tab eventKey="tabbanking" title="Banking"  className="tabbanking">
      <div className="bannerimagmobile">
          <button className="mobileabso" onClick={() => window.location.href='category/banking'}>{t("HOMEPAGE.BANKING")} <span><img src={rimib55} alt='{t("HOMEPAGE.BANKING")}'/></span> </button> 
          <img src={Bankingmobilebanner}  alt='{t("HOMEPAGE.BANKING")}'/>
      </div>
      </Tab>
    </Tabs>
                </section>
            
                </>
  )
}
